<template>
    <basic-header pretitle="aqfer Universal Tag" title="aUT Credentials" buttonText="Add Credential" :buttonRoles="credentialWriteAccessRoles"
        @btnClick="showModal({ component: 'addAutCredentials', data: { refreshCredentials: fetchCredentials } })" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <datatable tableId="aUTCredentials" :columns="columns" uniqueField="saltID" :data="credentials"
                        :ignoreCache="true" :compact="true" :showLoading="loading" :selectCheckboxes="$store.getters.userRoles.isAccessByRole(credentialWriteAccessRoles)"
                        :deletable="$store.getters.userRoles.isAccessByRole(credentialWriteAccessRoles)" @deleteRows="deleteCredentials" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BasicHeader from '../../components/BasicHeader.vue';
import Datatable from "../../components/Datatable.vue";
import { mapActions } from "vuex";
import jQuery from "jquery";
export default {
    components: { Datatable, BasicHeader },
    data() {
        return {
            columns: [
                {
                    data: "saltID",
                    title: "Salt ID",
                    className: "salt-id-column",
                    render: function (data, type, row) {
                        return `${data} <button type="button" class="btn btn-sm btn-copy-salt-id copy-salt-id" data-salt-id="${data}" title="Copy Salt ID"><i class="fa fa-copy"></i></button>`;
                    }
                },
                {
                    data: "url",
                    className: "url-column-wrap"
                },
            ],
            credentials: [],
            loading: false,
            credentialWriteAccessRoles: [1, 1.5, 3]
        };
    },
    async beforeMount() {
        await this.fetchCredentials();
    },
    mounted() {
        this.setupCopyIconListeners();
    },
    watch: {
        credentials() {
            this.$nextTick(() => {
                this.setupCopyIconListeners();
            });
        }
    },
    methods: {
        ...mapActions({
            showModal: "showModal",
            fetchAutCredentials: "aut/fetchAutCredentials",
        }),
        setupCopyIconListeners() {
            const self = this;
            // Remove existing listeners to avoid duplicates
            jQuery(`#aUTCredentials`).off('click', '.copy-salt-id');
            // Add click listener for copy buttons
            jQuery(`#aUTCredentials`).on('click', '.copy-salt-id', function (e) {
                e.stopPropagation();
                e.preventDefault();
                const saltID = jQuery(this).data('salt-id');
                if (saltID) {
                    self.copyToClipboard(saltID);
                }
            });
        },
        async copyToClipboard(text) {
            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(text);
                } else {
                    // Fallback for older browsers
                    const input = document.createElement('textarea');
                    input.style.position = 'absolute';
                    input.style.left = '-9999px';
                    input.value = text;
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input);
                }
                this.$store.dispatch('addToast', {
                    message: "Salt ID copied to clipboard.",
                    type: "success"
                });
            } catch (err) {
                this.$store.dispatch('addToast', {
                    message: "Failed to copy Salt ID.",
                    type: "error"
                });
            }
        },
        async fetchCredentials() {
            this.loading = true;
            await this.fetchAutCredentials().then((response) => {
                this.credentials = response.data?.items ? response.data.items : [];
            }).catch(err => {
                let error = err.response?.data.error ? err.response.data.error : err.message;
                let toastOptions = {
                    message: error || "Something went wrong while fetching credentials. Please contact support.",
                    type: "error"
                }
                this.$store.dispatch("addToast", toastOptions);
            }).finally(() => {
                this.loading = false;
            })
        },
        async deleteCredentials(rows) {
            this.showModal({
                component: "deleteAutCredentials", data: {
                    credentials: rows,
                    refreshCredentials: this.fetchCredentials,
                    screensize: 'xl'
                }
            });
        }
    }
};
</script>

<style>
#aUTCredentials .btn-copy-salt-id {
    margin-left: 8px;
    padding: 2px 8px;
    font-size: 12px;
    line-height: 1.5;
    border: 1px solid #d5e5fa;
    background-color: #f8f9fa;
    color: #2c7be5;
    vertical-align: middle;
    transition: all 0.2s ease;
}

#aUTCredentials .btn-copy-salt-id:hover {
    background-color: #2c7be5;
    color: #ffffff;
    border-color: #2c7be5;
}

#aUTCredentials .btn-copy-salt-id:active {
    background-color: #1e5bb8;
    border-color: #1e5bb8;
    transform: scale(0.95);
}

#aUTCredentials .btn-copy-salt-id i {
    margin: 0;
}

#aUTCredentials td.salt-id-column {
    max-width: none !important;
    white-space: nowrap !important;
    width: auto !important;
}

#aUTCredentials th.salt-id-column {
    width: auto !important;
}

#aUTCredentials td.url-column-wrap {
    max-width: none !important;
    white-space: normal !important;
    word-wrap: break-word;
    word-break: break-all;
    overflow-wrap: break-word;
    min-width: 300px;
    width: 60% !important;
}

#aUTCredentials th.url-column-wrap {
    min-width: 300px;
    width: 60% !important;
}
</style>
